import { EmptyTableMessage } from "@/core/components/empty-table-message";
import { SimpleTable } from "@/core/components/simple-table";
import { IPayout } from "@/payouts/payouts";
import { AdvocateCol } from "./cols/advocate-col";
import { AmountCol } from "./cols/amount-col";
import { DatePaidCol } from "./cols/date-paid-col";
import { NoteCol } from "./cols/note-col";
import { ReferralCol } from "./cols/referral-col";
import { StatusCol } from "./cols/status-col";

interface ReferralPaymentsTableProps {
  data: IPayout[];
  className?: string;
  isLoading?: boolean;
  onRowClick?: (row: IPayout) => void;
  selectedReferralPaymentId?: string;
  enablePagination?: boolean;
}

const columns = [
  ReferralCol(),
  AdvocateCol(),
  AmountCol(),
  DatePaidCol(),
  StatusCol(),
  NoteCol(),
];

export const ReferralPaymentsTable = ({
  data,
  className,
  isLoading,
  onRowClick,
  selectedReferralPaymentId,
  enablePagination,
}: ReferralPaymentsTableProps) => {
  if (data.length === 0 && !isLoading) {
    return <EmptyTableMessage />;
  }

  return (
    <SimpleTable
      data={data}
      columns={columns}
      className={className}
      isLoading={isLoading}
      onRowClick={onRowClick}
      selectedRowId={selectedReferralPaymentId}
      enablePagination={enablePagination}
    />
  );
};
